module.exports = __webpack_public_path__ + "static/assets/f2b55dc8ec1ae9e4a5c72088a185dad2.svg";